import AppStoreContext from 'contexts/AppStoreContext';
import ECSEditorContext from 'contexts/ECSEditorContext';
import ECSOverlayContext from 'contexts/ECSOverlayContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import Link from 'editor/components/Link';
import React, { useContext, useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Link as LinkRecord } from 'records/Link';

interface Props extends RouteComponentProps {
  link: LinkRecord;
}

const ECSLink = (props: Props) => {
  const { link, history } = props;
  const world = useContext(ECSWorldContext);
  const { doc } = useContext(ECSEditorContext);
  const appStore = useContext(AppStoreContext);
  const overlay = useContext(ECSOverlayContext);

  const { state } = appStore;

  const redirectToNextView = () => {
    if (link?.destinationurl !== '') {
      window.open(link.destinationurl, '_blank');
    } else if (link?.destinationsheetnumber !== '') {
      const nextSheetView = `/project/${state.selectedProject}/sheet/${link.destinationsheetnumber}/view`;
      history.push(nextSheetView);
    }
  };

  const linkClicked = () => redirectToNextView();

  useEffect(() => {
    const newLink = new Link(link.boundingBox.toArray(), linkClicked, link);

    world.createEntity().add(doc).add(overlay).add(newLink);
  });

  return <></>;
};

export default withRouter(ECSLink);
